import { updateCompany, getCompanies } from "../api/companyService";

/**
 * Hook for updating a company and syncing with local state.
 * @param {Function} setCompanies - setter from useCompanies
 */
export const useUpdateCompany = (setCompanies) => {
  const update = async (id, data) => {
    try {
        const updatedCompany = await updateCompany(id, data);
        const companiesResponse = await getCompanies();
        setCompanies(companiesResponse);
        return updatedCompany;
    } catch (error) {
        console.error("Failed to update company:", error);
        throw error;
    }
  };

  return { update };
};